<template>
  <div class="search_view">
    <div class="sidebar">
      <Sidebar />
    </div>
    <div class="center">
      <div v-if="loaded">
        <span v-if="empty"
          >We havent found any cars that match your criteria</span
        >
        <span v-if="no_tariff">Zero credits left.</span>
        <span v-else>Requests left {{ requests_left }}</span>

        <div class="content" v-else>
          <CarListItem v-for="offer in offers" :key="offer" :car_data="offer" />

          <Trigger v-if="loaded" @triggerIntersected="getMoreOffers" />
        </div>
      </div>
      <div v-else>
        <img
          src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif"
          class="spinner"
        />
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar.vue";
import CarListItem from "@/components/CarListItem.vue";
import Trigger from "@/components/Trigger.vue";

import axios from "axios";
export default {
  data() {
    return {
      offers: [],
      page: 1,
      max_page: 0,
      empty: false,
      no_tariff: false,
      loaded: false,
      requests_left: 0,
      selected: {
        odometer_from: "0",
        odometer_to: "100",
        auction_name: "",
        auction_date_from: "2000-12-08",
        auction_date_to: "2000-12-08",
        estimated_retail_value_from: 0,
        estimated_retail_value_to: 10000,
      },
    };
  },
  beforeMount() {
    this.getOffers();
  },
  methods: {
    async getOffers() {
      this.loaded = false;
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-car-vin/",
        {
          api_token: "string",
          search: this.$route.query.vin_number,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log("GET CAR VIN DATA:", data);
      this.requests_left = data["apiRequestLeft"];
      if (data["message"] == "No active tariff found.") {
        this.no_tariff = true;
      } else {
        this.max_page = 1;
        this.offers = data["result"];
        console.log(this.offers);
        this.loaded = true;
      }
    },
  },
  components: {
    CarListItem,
    Trigger,
    Sidebar,
  },
};
</script>
<style scoped>
.search_view {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 420px 1fr;
  gap: 0px 0px;
  background: #edf2f7;
}
.sidebar {
  border: 4px solid #edf2f7;
  width: 100%;
  padding-top: 10px;
}
.center {
  background: #edf2f7;
  width: 100%;
}
.spinner {
  height: 100px;
  margin: auto;
  display: block;
}
select[name="vehicle"] {
  border: 2px solid #edf2f7;
  padding: 9px;
  text-align: center;
  width: 150px;
}

@media only screen and (max-width: 1000px) {
  .search_view {
    grid-template-columns: 1fr;
  }
}

@media only screen and (min-width: 600px) {
  .search_view .center .content {
    padding: 30px;
  }

  .search_view .center {
    padding: 0;
  }
}
</style>
